import { COMMANDS } from '../../utils/commonProperties';
import * as THREE from 'three';
import React, { useState, useRef, useEffect } from 'react';
import { usePanelModify } from '../../modules/panel';
import { useDispatch ,useSelector} from 'react-redux';
import { useDragHandler } from '../../utils/useDragHandler';
import './PanelTypeMenus.css'
import { setLastBasePoint } from '../../redux/utilsSlice';
import { startSimpleMainPanelDrawing } from '../../modules/panel';
import ADPDetails from './ADPDetails';
import CabinDetails from './CabinDetails';
import { getObjectById } from '../../utils/getObjectById';

export default function BoxTypeMenu({
  x,
  y,
  value,
  onClose,
  onAddPositionChange,
  onActionSelect,
  boxDetails,
  onDrag,
  scene,
}) {
  const basePoint= boxDetails.basePoint || { x: 0, y: 0, z: 0 };
  const dispatch = useDispatch();
  const [boxName,setBoxName]=useState("BOX")
  const [panel ,setPanel ]=useState(null)
  const [details,setDetails]=useState({
    kullanimAmac:"Box",
    phaseCount:3,
    panoAdi: "ADP",
    tur: "Tek Sayaç"
  }) 
  const menuRef = useRef(null);
  const projectType = "MVP";
  const panelId = boxDetails.id || null;
  const [selectedAction, setSelectedAction] = useState("MVP");
 useEffect(() => {
  dispatch(setLastBasePoint(basePoint));
}, [dispatch, basePoint]);

  useEffect(()=>{
   
  },[details]) 

  useEffect(()=>{
    if(!panel)return
  
    const updatedPanel= updatePanel(panel)
    setDetails(updatedPanel.details)
  },[panel]) 

  const { setCount ,updatePanel} = usePanelModify(scene);

 
const handleActionWithDetails = (command) => {
  // ✅ SIMPLE SUPPLY POINT: Start feeder drawing from Box to ADP (like original system)
  const panel = getObjectById(scene, panelId);
  if (!panel) return;

  // Get position from the supply point (Box).
  // Mesh-FP mimarisinde box, fpMesh'in child'ıdır → panel.position LOCAL'dir.
  // Wire çizimi WORLD koordinatta olduğundan world konumu kullanmalıyız; aksi
  // halde mainPanel wire'ı box yerine origin civarından (local coords) başlıyordu.
  const supplyPosition = new THREE.Vector3();
  panel.getWorldPosition(supplyPosition);

  // ✅ Start Simple Main Panel drawing with feeder line preview (like original)
  startSimpleMainPanelDrawing(dispatch, panelId, {
    x: supplyPosition.x,
    y: supplyPosition.y,
    z: 0
  }, details );

   onClose();

};


 
  const { handleMouseDown, handleMouseMove, handleMouseUp } = useDragHandler(onDrag);

  const handleMouseDownWithStop = (e) => {
    e.stopPropagation();
    handleMouseDown(e);
  };
 
  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      ref={menuRef} className="panel-type-menu" style={{ left: x, top: y }}
    >
      <div
        onMouseDown={handleMouseDownWithStop}
        className="panel-type-menu-header"
      > 
        {boxName } /{details.kuruluGuc} W
        <button
          className="close-button"
          onClick={e => { e.stopPropagation(); onClose(); }}
        >
          ×
        </button>
      </div>

      <div  className="panel-type-options">
  
{selectedAction === "MVP" && (
 <ADPDetails
    details={details}
    setDetails={setDetails}
    onApply={() => handleActionWithDetails(COMMANDS.DRAW_MAIN_PANEL)}
  />
  
)}

{selectedAction === "MVP2" && (
  <CabinDetails details={details} setDetails={setDetails} />
)}
        <div>
           
 
        </div>
      </div>
    </div>
  );
}

 